<template>
  <v-container fluid align-start ma-0 pa-2 class="epms1020_detail-main container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" 
          :useBtnList="useBtnList"
          :unUseBtnList="unUseBtnList"
          :btnKey="useBtnListKey"
          @btnRetrieve="btnRetrieve"
          @btnBomListToExcel="btnBomListToExcel"
          @btnSave="btnSave"
          @btnCopy="btnCopy"
          @btnSubmitToHVS="btnSubmitToHVS"
        >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col cols="12" class="px-1">
                <i-label :label="'Basic Information : '"/>
              </v-col>
            </v-row>

            <v-row dense class="form-layout">
              <v-col cols="12" class="pa-0">
                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Quotation No</span>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters class="row__select-no">
                      <v-col cols="6">
                        <v-select
                          v-model="selectedQuot"
                          :items="quotList"
                          item-value="quotNo"
                          item-text="quotNo"
                          label="Select No"
                          return-object
                          single-line
                          outlined
                          dense
                          @change="quotNoChange"
                        ></v-select>
                      </v-col>
                      <v-col cols="6" class="pl-2 pt-1 quotNo">
                        {{ quotStepGbn }} 
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Title</span>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field 
                      v-model="headerData.quotTitle" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Ship No, POR No</span>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters >                     
                      <v-col cols="6">
                        <v-text-field 
                          v-model="headerData.shipPorNo" 
                          dense 
                          outlined 
                          hide-details="auto"
                          readonly
                        />
                    </v-col>
                    <v-col cols="6">
                      <v-row no-gutters>
                        <v-col cols="4" align="right" class="pr-2 pt-1 formHeader">                      
                         <span>Ship No</span>                     
                        </v-col>
                        <v-col cols="8" >                      
                          <v-select
                          v-model="selectedShip"
                          :items="shipList"
                          item-value="shipNo"
                          item-text="shipNo"
                          label="All Ship"
                          return-object
                          single-line
                          outlined
                          dense
                          @change="shipNoChange"
                        ></v-select>              
                        </v-col>
                      </v-row>                     
                    </v-col>                   
                    </v-row>                    
                  </v-col>                 
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Start Date</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.startDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Finish Time</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.finishDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Delivery Condition</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.transCondDesc" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Payment Condition</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.payCondDesc" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Purchase Charger</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.buyerName" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>
                
                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Recieve Date</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.receiveDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Submit Date</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.submitDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Quotation Amount</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.quotationAmount"
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Remark</span>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field 
                      v-model="headerData.remark" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Money Unit</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="headerData.moneUnit"
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" class="pt-1">
                <DxDataGrid id="epms1020Detail" 
                  :ref="epms1020DetailRef"
                  class="hipGridHeight5"
                  :data-source="dataList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="id" 
                  :focused-row-enabled="false"
                  :column-hiding-enabled="false" 
                  :selection="{ mode: 'none' }"
                  :sorting="{ mode: 'none' }"
                  @cellPrepared="cellPrepared"
                  @editingStart="editingStart"
                  @contentReady="contentReady"
                  :repaint-changes-only="true"
                >
                  <DxEditing :use-icons="true" />
                  <!-- <DxPaging :enabled="true" /> -->
                  <DxPaging :enabled="true" :page-size="10" />
                  <DxPager :allowed-page-sizes="[10, 'all']" />
                  <DxColumn caption="No" data-field="no" alignment="center" :allow-editing="false" />
                  <DxColumn caption="Ship No">
                    <DxColumn caption="POR No" data-field="shipNo" alignment="center" :allow-editing="false" />
                  </DxColumn>
                  <DxColumn caption="Block">
                    <DxColumn caption="Part No" data-field="block" alignment="center" :allow-editing="false" />
                  </DxColumn>
                  <DxColumn caption="P.Qty">
                    <DxColumn caption="Material Specification" data-field="partQty" alignment="center" :allow-editing="false"
                                          data-type="string" :format="format" />
                  </DxColumn>
                  <DxColumn caption="Unit Wgt">
                    <DxColumn caption="Material Specification1" data-field="partUnitWgt" alignment="right"
                                          :set-cell-value="setPartUnitWgt" data-type="string" :format="format" :editor-options="{ maxLength: 12 }" />
                  </DxColumn>
                  <DxColumn caption="Total Wgt">
                    <DxColumn caption="Material Specification2" data-field="totWgt" alignment="center" :allow-editing="false"
                                          data-type="string" :format="format" />
                  </DxColumn>
                  <DxColumn caption="Production Fee">
                    <DxColumn :caption="caption" header-cell-template="btnAllTmpl" data-field="sepAmt" alignment="right"
                                          :set-cell-value="setSepAmt" data-type="string" :format="format" :editor-options="{ maxLength: 12 }"
                                          :allow-editing="editGbn === '0'" :cell-template="editGbn === '2' ? 'hideTmpl' : ''" />
                    <DxColumn caption="Prod." header-cell-template="btnAllTmpl" data-field="proAmt" alignment="right"
                                          :set-cell-value="setProAmt" data-type="string" :format="format" :editor-options="{ maxLength: 12 }"
                                          :allow-editing="editGbn === '0'" :cell-template="editGbn === '2' ? 'hideTmpl' : ''" />
                    <DxColumn caption="Gal Qty" header-cell-template="btnAllTmpl" data-field="galQty" alignment="right" width="4%"
                                          :set-cell-value="setGalQty" data-type="string" :format="format" :editor-options="{ maxLength: 12 }"
                                          :allow-editing="editGbn === '0'" :cell-template="editGbn === '2' ? 'hideTmpl' : ''" />
                    <DxColumn caption="Gal." header-cell-template="btnAllTmpl" data-field="galAmt" alignment="right" width="4%"
                                            :set-cell-value="setGalAmt" data-type="string" :format="format" :editor-options="{ maxLength: 12 }"
                                            :allow-editing="editGbn === '0'" :cell-template="editGbn === '2' ? 'hideTmpl' : ''" />
                    <DxColumn caption="Paint" header-cell-template="btnAllTmpl" data-field="pntAmt" alignment="right"
                                          :set-cell-value="setPntAmt" data-type="string" :format="format" :editor-options="{ maxLength: 12 }"
                                          :allow-editing="editGbn === '0'" :cell-template="editGbn === '2' ? 'hideTmpl' : ''" />
                    <DxColumn caption="SP" header-cell-template="btnAllTmpl" data-field="spAmt" alignment="right"
                                          :set-cell-value="setSpAmt" data-type="string" :format="format" :editor-options="{ maxLength: 12 }"
                                          :allow-editing="editGbn === '0'" :cell-template="editGbn === '2' ? 'hideTmpl' : ''" />
                    <DxColumn caption="Treatment" header-cell-template="btnAllTmpl" data-field="trmAmt" alignment="right"
                                          :set-cell-value="setTrmAmt" data-type="string" :format="format" :editor-options="{ maxLength: 12 }"
                                          :allow-editing="editGbn === '0'" :cell-template="editGbn === '2' ? 'hideTmpl' : ''" />
                    <DxColumn caption="Sub. Total" data-field="subAmt" alignment="right"
                                          data-type="string" :format="format"
                                          :allow-editing="false" :cell-template="editGbn === '2' ? 'hideTmpl' : ''" />
                    <DxColumn caption="Others" data-field="othAmt" alignment="right"
                                          :set-cell-value="setOthAmt" data-type="string" :format="format" :editor-options="{ maxLength: 12 }"
                                          :allow-editing="editGbn === '0'" :cell-template="editGbn === '2' ? 'hideTmpl' : ''" />
                    <DxColumn caption="ACC" data-field="accAmt" cell-template="accTmpl" :allow-editing="false" />
                    <DxColumn caption="Total" data-field="totAmt" alignment="right"
                                          data-type="string" :format="format"
                                          :allow-editing="false" :cell-template="editGbn === '2' ? 'hideTmpl' : ''" />
                  </DxColumn>
                  <template #hideTmpl>
                    ************
                  </template>
                  <template #accTmpl="{ data }">
                    <template v-if="data.data.rnum === 1">
                      <div class="text-right">
                        {{ getNumComma(data.data.accAmt) }}
                      </div>
                    </template>
                    <template v-else>
                      <div class="text-center">
                        <i-button :text="'ACC'" :isCustom="true" @click="btnAcc(data)" />
                      </div>
                    </template>
                  </template>
                  <template #btnAllTmpl="{ data }">
                    <fragment>
                      <div>
                        {{ data.column.caption }}
                      </div>
                      <div>
                        <i-button :text="'All'" :isCustom="true" @click="btnAll(data.column.dataField)" />
                      </div>
                    </fragment>
                  </template>

                  <DxSummary>
                    <DxTotalItem column="shipNo" summary-type="count" display-format="Total" />
                    <DxTotalItem column="partQty" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="partUnitWgt" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="totWgt" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="sepAmt" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="proAmt" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="galAmt" summary-type="sum" :customize-text="totalFormat" />
                    <!-- <DxTotalItem name="galQty" show-in-column="galQty" summary-type="custom" /> -->
                    <DxTotalItem column="pntAmt" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="spAmt" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="trmAmt" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="subAmt" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="othAmt" summary-type="sum" :customize-text="totalFormat" />
                    <DxTotalItem column="accAmt" summary-type="sum" :customize-text="totalFormat" alignment="right" />
                    <DxTotalItem column="totAmt" summary-type="sum" :customize-text="totalFormat" />
                  </DxSummary>
                </DxDataGrid>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>

    <epms1020Acc :showEpms1020Acc.sync="showEpms1020Acc" :param="epms1020AccParam" @saveAcc="btnRetrieve" />
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import notify from 'devextreme/ui/notify'
import { getQuotNoOutList, getRequestHead, getSubmitDetail1, getSave1020Check, setSave1020Det, setSubmit1020Det } from '@/api/view/hip/common/common'
import { getNumComma, toNum } from '@/utils/common.js'
import iButton from '@/components/common/iButton'
import epms1020Acc from '@/views/hip/1/popup/epms1020_acc'
import { epms7030xls } from '@/api/view/hip/common/commonXls'
import { epmsa1020copy, epmsa1020ShipLoad, checkRemainShip } from '@/api/view/hip/1/epms1020'

export default {
  name: 'epms1020_detail',
  mixins: [baseview, BaseDataGrid],
  components: {
    iButton,
    epms1020Acc
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      epms1020DetailRef: 'epms1020DetailRef',
      quotList: [],
      shipList: [],
      dataList: [],
      shipRemain : '',
      selectedQuot: null,
      selectedShip: null,
      useBtnListKey: 0,
      useBtnList: ['btnRetrieve', 'btnBomListToExcel', 'btnSave', 'btnCopy', 'btnSubmitToHVS'],
      useBtnListTemp: ['btnRetrieve', 'btnBomListToExcel', 'btnSave', 'btnCopy', 'btnSubmitToHVS'],
      unUseBtnList: [],
      headerData: {},
      editGbn: '0', // '0', '1', '2'
      quotStepGbn: '',
      caption: '',
      format: '#,##0.############',
      isRefresh: false,
      saveChk: null,
      showEpms1020Acc: false,
      epms1020AccParam: null,
       isHVSip: false
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms1020DetailRef)
    }
  },
  mounted() {
    this.gridInstance.option('defaultPaging', false)
    this.setHVSIp()
    this.setCaption()
    this.getQuotNoOutList()
  },
  methods: {
    setHVSIp() {
      const logIP = this.$store.state.user.userIp
      const userGrd = this.$store.state.user.userGrd
      const userId = this.$store.state.user.userId

      if (('192.168.46.5' === logIP || '192.168.48.' === logIP.substr(0, 11) || '192.168.50.' === logIP.substr(0, 11) || '192.168.51.' === logIP.substr(0, 11)
          || '192.168.52.' === logIP.substr(0, 11) || '192.168.53.' === logIP.substr(0, 11) || '192.168.54.' === logIP.substr(0, 11)
          || '192.168.55.' === logIP.substr(0, 11) || '192.168.56.' === logIP.substr(0, 11) || '192.168.57.' === logIP.substr(0, 11)
          || '192.168.58.' === logIP.substr(0, 11) || '192.168.61.' === logIP.substr(0, 11) || '192.168.68.' === logIP.substr(0, 11)
          || '192.168.70.' === logIP.substr(0, 11))
          && !'A' === userGrd && !'95935' === userId && !'95987' === userId && !'11951' === userId && !'11246' === userId && !'10403' === userId && !'11272' === userId && !'10252' === userId)
      {
        this.isHVSip = true;
      }
    },
    totalFormat(e) {
      const result = getNumComma(Number(e.value.toFixed(2)), 2)
      return result
    },
    getNumComma(e) {
      const result = getNumComma(e, 2)
      return result
    },
    initData() {
      this.headerData = {
        receiveYn: 'N',
        submitYn: 'N',
        printYn: 'N',
        saveYn: 'N',
        quotStep: 'A1'
      }
      this.quotStepGbn = ''
      this.dataList = []
      this.unUseBtnList = []
      this.useBtnList = [],
      this.editGbn = '0'
    },
    setCaption() {
      if(this.$store.state.user.makerCd === '10252') {
        this.caption = 'Matl.'
      } else if(this.$store.state.user.makerCd === '13153') {
        this.caption = 'Trans.'
      } else {
        this.caption = 'Sper.'
      }
    },
    async getShipNo() {
      const param = {
        quotNo: this.selectedQuot.quotNo
      
      }
      console.log('param', param)
      await epmsa1020ShipLoad(param).then(res => {
        console.log('res', res)
        this.shipList = res.list
        if(this.shipList.length > 0) {
          this.shipList.unshift({   
          cnt : 0,      
          shipNo: 'All',
          setShip : ''
        })
          if(this.shipList[1].cnt > 3){
            this.selectedShip =  this.shipList.find(element => element.shipNo === this.shipList[1].shipNo) 
          }else{
            this.selectedShip = this.shipList[0]
          }          
        }
      })
    },
    async getQuotNoOutList() {
      const param = {
        makerCd: this.$store.state.user.makerCd,
        quotStep: 'A',
        quotDiv: 'N',
        userId: this.$store.state.user.userId,
      }

      await getQuotNoOutList(param).then(res => {
        // console.log('res', res)
        
        const setVal = res.list.find(element => element.quotNo === this.$route.params.quotNo)

        this.quotList = res.list
        this.selectedQuot = setVal
        this.quotNoChange(setVal)        
          
      })
    },
    quotNoChange(e) {
      if(e) {
        switch(e.quotStep) {
          case 'A2': this.quotStepGbn = '1st re-Quot'
            break
          case 'A3': this.quotStepGbn = '2nd re-Quot'
            break
          case 'A4': this.quotStepGbn = '3rd re-Quot'
            break
          default: this.quotStepGbn = ''
            break
        }

        if(this.selectedQuot){
          this.selectedShip = null
          this.getShipNo().then(() => {
            this.getQuotData()
          })
        }

        //this.getQuotData()
       
      }
    },
    shipNoChange(e) {
      if(e) {
        this.getQuotData()
      }
    },
    setBtnList() {
      let btnTemp = this.$_.cloneDeep(this.useBtnListTemp)

      // console.log('this.headerData.submitYn', this.headerData.submitYn)
      // console.log('this.headerData.pipeYn', this.headerData.pipeYn)

      if(this.headerData.submitYn === 'Y') {
        this.unUseBtnList.push('btnSave')
        this.unUseBtnList.push('btnSubmitToHVS')
      }

      // console.log('btnTemp', btnTemp)

      this.useBtnList = btnTemp
      this.useBtnListKey++
    },
    async getQuotData() {
       try {
        this.initData()
        this.openLoading('searching')

        const param = {
          quotNo: this.selectedQuot.quotNo,
          quotStep: this.selectedQuot.quotStep,
          makerCd: this.$store.state.user.makerCd,
          quotDiv: '',
          shipNo: this.selectedShip ? this.selectedShip.shipNo == 'All' ? '%' : this.selectedShip.shipNo : ''
        }
        console.log('param', param)
        console.log('selectedShip', this.selectedShip)
        await getSave1020Check(param).then(res => {
          // console.log('saveCheckRes', res)

          if(res.list && res.list.length > 0) {
            this.saveChk = res.list[0].yn
          }
        })

        await getRequestHead(param).then(res => {
          // console.log('headRes', res)

          if(res.list.length > 0) {
            this.headerData = res.list[0]

            this.headerData.quotationAmount = 0
            this.headerData.payPct = 0

            if(!this.headerData.submitYn || this.headerData.submitYn === 'N') {
              this.editGbn = '0'
            } else if(!this.headerData.printYn || this.headerData.printYn === 'N') {
              this.editGbn = '1'
            } else {
              this.editGbn = '2'
            }
          }
        })

        await getSubmitDetail1(param).then(res => {
          // console.log('submitDetail1Res', res)

          let result = res.list
          let makeData = []

          let id = 0
          for(let i = 0; i < result.length; i++) {
            id++

            makeData.push({
              id: id,
              no: result[i].id,
              shipNo: result[i].shipNo,
              block: result[i].block,
              partQty: result[i].partQty * 1,
              partUnitWgt: result[i].partUnitWgt * 1,
              totWgt: result[i].totWgt * 1,
              sepAmt: result[i].sepAmt * 1,
              proAmt: result[i].proAmt * 1,
              galQty: result[i].galQty * 1,
              galAmt: 0,
              pntAmt: result[i].pntAmt * 1,
              spAmt: result[i].spAmt * 1,
              trmAmt: result[i].trmAmt * 1,
              subAmt: result[i].subAmt * 1,
              othAmt: result[i].othAmt * 1,
              accAmt: result[i].accAmt * 1,
              totAmt: result[i].totAmt * 1,
              rnum: 1,
              unit: result[i].unit,
              matlCd: result[i].matlCd,
              mact: result[i].mact,
              bomSerno: result[i].bomSerno,
              porSeq: result[i].porSeq
            })

            id++
            makeData.push({
              id: id,
              no: result[i].id,
              shipNo: result[i].porNo,
              block: result[i].partNo,
              partQty: result[i].partSpec,
              partUnitWgt: null,
              totWgt: null,
              sepAmt: 0,
              proAmt: 0,
              galQty: 0,
              galAmt: result[i].galAmt * 1,
              pntAmt: 0,
              spAmt: 0,
              trmAmt: 0,
              subAmt: 0,
              othAmt: 0,
              accAmt: 0,
              totAmt: 0,
              rnum: 2,
              unit: result[i].unit,
              matlCd: result[i].matlCd,
              mact: result[i].mact,
              bomSerno: result[i].bomSerno,
              porSeq: result[i].porSeq
            })
          }

          // console.log('makeData', makeData)

          this.dataList = makeData
        })

        this.setBtnList()
      } finally {
        this.endLoading()
      }
    },
    setPartUnitWgt(newData , value, currData) {
      const val = toNum(value)
      this.dataList[currData.id - 1].partUnitWgt = val

      const temp = this.$_.cloneDeep(currData)
      temp.partUnitWgt = val

      const result = this.calcTotal(temp)
      this.dataList[currData.id - 1].subAmt = result.subAmt
      this.dataList[currData.id - 1].totAmt = result.totAmt
    },
    setSepAmt(newData , value, currData) {
      const val = toNum(value)
      this.dataList[currData.id - 1].sepAmt = val

      const temp = this.$_.cloneDeep(currData)
      temp.sepAmt = val

      const result = this.calcTotal(temp)
      this.dataList[currData.id - 1].subAmt = result.subAmt
      this.dataList[currData.id - 1].totAmt = result.totAmt
    },
    setProAmt(newData , value, currData) {
      const val = toNum(value)
      this.dataList[currData.id - 1].proAmt = val

      const temp = this.$_.cloneDeep(currData)
      temp.proAmt = val

      const result = this.calcTotal(temp)
      this.dataList[currData.id - 1].subAmt = result.subAmt
      this.dataList[currData.id - 1].totAmt = result.totAmt
    },
    setGalQty(newData , value, currData) {
      const val = toNum(value)
      this.dataList[currData.id - 1].galQty = val

      const temp = this.$_.cloneDeep(currData)
      temp.galQty = val

      const result = this.calcTotal(temp)
      if(currData.rnum === 2) {
        this.dataList[currData.id - 2]['subAmt'] = result.subAmt
        this.dataList[currData.id - 2]['totAmt'] = result.totAmt
        // this.gridInstance.cellValue(currData.id - 2, 'subAmt', result.subAmt)
        // this.gridInstance.cellValue(currData.id - 2, 'totAmt', result.totAmt)
      } else {
        this.dataList[currData.id - 1].subAmt = result.subAmt
        this.dataList[currData.id - 1].totAmt = result.totAmt
      }
    },
    setGalAmt(newData, value, currData) {
      const val = toNum(value)
      this.dataList[currData.id - 1].galAmt = val
      
      const temp = this.$_.cloneDeep(currData)
      temp.galAmt = val      

      const result = this.calcTotal(temp)      

      console.log(result)
      
      if (currData.rnum === 2) {
        this.dataList[currData.id - 2]['subAmt'] = result.subAmt
        this.dataList[currData.id - 2]['totAmt'] = result.totAmt
        // this.gridInstance.cellValue(currData.id - 2, 'subAmt', result.subAmt)
        // this.gridInstance.cellValue(currData.id - 2, 'totAmt', result.totAmt)
      } else {
        this.dataList[currData.id - 1].subAmt = result.subAmt
        this.dataList[currData.id - 1].totAmt = result.totAmt
      }
    },
    setPntAmt(newData , value, currData) {
      const val = toNum(value)
      this.dataList[currData.id - 1].pntAmt = val

      const temp = this.$_.cloneDeep(currData)
      temp.pntAmt = val

      const result = this.calcTotal(temp)
      this.dataList[currData.id - 1].subAmt = result.subAmt
      this.dataList[currData.id - 1].totAmt = result.totAmt
    },
    setSpAmt(newData , value, currData) {
      const val = toNum(value)
      this.dataList[currData.id - 1].spAmt = val

      const temp = this.$_.cloneDeep(currData)
      temp.spAmt = val

      const result = this.calcTotal(temp)
      this.dataList[currData.id - 1].subAmt = result.subAmt
      this.dataList[currData.id - 1].totAmt = result.totAmt
    },
    setTrmAmt(newData , value, currData) {
      const val = toNum(value)
      this.dataList[currData.id - 1].trmAmt = val

      const temp = this.$_.cloneDeep(currData)
      temp.trmAmt = val

      const result = this.calcTotal(temp)
      this.dataList[currData.id - 1].subAmt = result.subAmt
      this.dataList[currData.id - 1].totAmt = result.totAmt
    },
    setOthAmt(newData , value, currData) {
      const val = toNum(value)
      this.dataList[currData.id - 1].othAmt = val

      const temp = this.$_.cloneDeep(currData)
      temp.othAmt = val

      const result = this.calcTotal(temp)
      this.dataList[currData.id - 1].subAmt = result.subAmt
      this.dataList[currData.id - 1].totAmt = result.totAmt
    },
    // calcCustomSummary(e) {
    //   if(e.name === 'galQty') {
    //     switch(e.summaryProcess) {
    //       case 'start':
    //         e.totalValue = 0
    //         break
    //       case 'calculate':
    //         if(e.value.rnum === 2) {
    //           e.totalValue += Number(e.value.galQty)
    //         }
    //         break
    //       case 'finalize':
    //         e.totalValue = this.getNumComma(e.totalValue)
    //         break
    //     }
    //   }
    // },
    contentReady(e) {
      const grd = e.component

      if(this.isRefresh) {
        grd.refresh(true)
        this.isRefresh = false
      }

      // if(grd.hasEditData() && grd.totalCount() > 0) {
      //   grd.saveEditData().then(() => {
      //     console.log('e', e)
      //   })
      // }
    },
    editingStart(e) {
      // console.log('e', e)

      if(e.column.dataField === 'partQty' || e.column.dataField === 'partUnitWgt' || e.column.dataField === 'totWgt') {
        if(e.data.rnum === 2) {
          e.cancel = true
        }
      }
    },
    cellPrepared(e) {
      if(e.rowType === 'header') {
        if(e.column.caption.indexOf('Material Specification') > -1) {
          if(e.column.caption === 'Material Specification') {
            e.cellElement.setAttribute('colspan', 3)
          } else {
            e.cellElement.style.display = 'none'
          }
        }
        if (e.column.caption === 'Gal.') {
          e.cellElement.setAttribute('colspan', 2)
        } else if (e.column.caption === 'Gal Qty') {
          e.cellElement.style.display = 'none'
        }
      } else if(e.rowType === 'data') {
        if(e.rowType === 'data' && e.rowIndex >= 0) {
          if(e.column.dataField === 'no') {
            if(e.data.rnum === 1) {
              e.cellElement.setAttribute('rowspan', 2)
            } else {
              e.cellElement.style.display = 'none'
            }
          } else if(e.column.dataField === 'partQty') {
            if(e.data.rnum === 2) {
              e.cellElement.setAttribute('colspan', 3)
              e.cellElement.style.textAlign = 'left'
              e.cellElement.classList.add('cancel-editable-cell')
            }
          } else if(e.column.dataField === 'partUnitWgt') {
            if(e.data.rnum === 2) {
              e.cellElement.style.display = 'none'
            }
          } else if(e.column.dataField === 'totWgt') {
            if(e.data.rnum === 2) {
              e.cellElement.style.display = 'none'
            }
          } else if(e.column.dataField === 'sepAmt'
                      || e.column.dataField === 'proAmt'
                      || e.column.dataField === 'pntAmt'
                      || e.column.dataField === 'spAmt'
                      || e.column.dataField === 'trmAmt'
                      || e.column.dataField === 'subAmt'
                      || e.column.dataField === 'othAmt'
                      || e.column.dataField === 'totAmt') {
            if(e.data.rnum === 1) {
              e.cellElement.setAttribute('rowspan', 2)
            } else {
              e.cellElement.style.display = 'none'
            }
          }
        }
        if (Number(e.rowIndex) % 2 === 0) { 
          if (e.column.name === 'galQty') {
                  e.cellElement.setAttribute('colspan', 2)
              } else if (e.column.name === 'galAmt') {
                  e.cellElement.style.display = 'none'

              }
        } else {
          if (e.column.name === 'galAmt') {
            e.cellElement.setAttribute('colspan', 2)
          } else if (e.column.name === 'galQty') {
            e.cellElement.style.display = 'none'

          }
        }
      }
    },
    btnAll(key) {
      
      for(let i = 0; i < this.dataList.length; i++){
        if(key === 'galAmt') {
          if(i % 2 === 1) {
            this.dataList[i][key] = this.dataList[1][key]
            const result = this.calcTotal(this.dataList[i])
            this.dataList[i - 1].subAmt = result.subAmt
            this.dataList[i - 1].totAmt = result.totAmt
          }
        } else {
          if(i % 2 === 0) {
            this.dataList[i][key] = this.dataList[0][key]
            const result = this.calcTotal(this.dataList[i])
            this.dataList[i].subAmt = result.subAmt
            this.dataList[i].totAmt = result.totAmt
          }
        }
      }
      
    },
    btnAcc(data) {
      const item = data.data
      const rnum1 = this.$_.find(this.dataList, { no: item.no, rnum: 1 })

      // console.log('rnum1', rnum1)
      // console.log('rnum2', item)
      
      const quotNo = this.selectedQuot.quotNo
      const shipNo = rnum1.shipNo
      const mact = rnum1.mact
      const bomSerno = rnum1.bomSerno
      const isSave = this.saveChk && this.saveChk === 'Y' ? true : false
      
      if(!isSave) {
        this.vToastify(this.$t('Please save detail quotation before inputing accessories.'), 'warn')
        return
      }

      this.epms1020AccParam = {
        quotNo,
        shipNo,
        mact,
        bomSerno
      }

      this.showEpms1020Acc = true
    },
    calcTotal(data) {
      // console.log('data', data)

      let rnum1
      let rnum2

      if(data.rnum === 1) {
        rnum1 = data
        //rnum2 = this.gridInstance.getVisibleRows()[this.gridInstance.getRowIndexByKey(data.id + 1)].data
        rnum2 = this.dataList[data.id]        
      } else {
        //rnum1 = this.gridInstance.getVisibleRows()[this.gridInstance.getRowIndexByKey(data.id - 1)].data 
        //console.log(data.id - 1)               
        rnum1 = this.dataList[data.id - 2]
        rnum2 = data
      }

       //console.log('rnum1', rnum1)
       //console.log('rnum2', rnum2)

      const partQty = rnum1.partQty
      const partUnitWgt = rnum1.partUnitWgt
      const totWgt = rnum1.totWgt
      const sepAmt = rnum1.sepAmt
      const proAmt = rnum1.proAmt
      const galQty = rnum1.galQty
      const galAmt = rnum2.galAmt
      const pntAmt = rnum1.pntAmt
      const spAmt = rnum1.spAmt
      const trmAmt = rnum1.trmAmt
      const othAmt = rnum1.othAmt
      const accAmt = rnum1.accAmt
      const matlUnit = data.unit
      const matlCd = data.matlCd

      // console.log('partQty', partQty)
      // console.log('partUnitWgt', partUnitWgt)
      // console.log('totWgt', totWgt)
      // console.log('sepAmt', sepAmt)
      // console.log('proAmt', proAmt)
      // console.log('galQty', galQty)
      // console.log('galAmt', galAmt)
      // console.log('pntAmt', pntAmt)
      // console.log('spAmt', spAmt)
      // console.log('trmAmt', trmAmt)
      // console.log('othAmt', othAmt)
      // console.log('accAmt', accAmt)
      // console.log('matlUnit', matlUnit)
      // console.log('matlCd', matlCd)

      let subAmt = 0
      let totAmt = 0 

      if(matlUnit === 'EA') {
        subAmt = (proAmt + trmAmt) * partQty + (galAmt * galQty) + (pntAmt + sepAmt + spAmt) * (partQty * partUnitWgt)
      } else {
        if(matlCd === '24221MPB00S') {
          subAmt = (proAmt * partQty) + (trmAmt * totWgt + pntAmt * totWgt + sepAmt * totWgt + spAmt * totWgt)  + (galAmt  * galQty)
        } else {
          subAmt = Math.round((proAmt + trmAmt + pntAmt + sepAmt + spAmt) * (partQty * partUnitWgt)  + (galAmt  * galQty))
        }
      }

      totAmt =  Math.round(subAmt +  othAmt +  accAmt)

      this.isRefresh = true

      return {
        subAmt,
        totAmt
      }
    },
    btnRetrieve() {
      // console.log('this.dataList', this.dataList)
      
      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('There is no quotation no.'), 'warn')
        return
      }

      this.quotNoChange(this.selectedQuot)
    },
    btnBomListToExcel() {
      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('Quotation number is not selected.'), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('Would You create the Excel file?'),
        'info',
        current => {
          // console.log('current', current)

          const param = {
            quotNo: this.selectedQuot.quotNo,
            makerCd: this.$store.state.user.makerCd,
            quotStep: this.headerData.quotStep
          }

            epms7030xls(param)
        },
        null,
        false
      )
    },
    btnSave() {
      const hvsIP = this.isHVSip
      const submitYn = this.headerData.submitYn ? this.headerData.submitYn : 'N'
      const receiveYn = this.headerData.receiveYn ? this.headerData.receiveYn : 'N'

      if(hvsIP) {
        this.vToastify(this.$t('Warning : You access to HiP System at the HVS Company.<br>You cannot submit the quotation in the HVS.<br>nCall IT Department.(2487, 2496, 2497).'), 'warn')
        return
      }

      if(submitYn === 'Y') {
        return
      }
      
      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('There is no quotation no.'), 'warn')
        return
      }

      if(receiveYn !== 'Y') {
        this.vToastify(this.$t('Not yet Received'), 'warn')
        return
      }

      // console.log('submitYn', submitYn)

      this.vToastifyPrompt(
        this.$t('Do you want to save the Quotation?'),
        'info',
        current => {
          this.openLoading('searching')

          let params = []

          for(let i = 0; i < this.dataList.length; i++) {
            if(this.dataList[i].rnum === 1) {
              params.push(this.dataList[i])
            } else if(this.dataList[i].rnum === 2) {
              params[params.length - 1].quotNo = this.headerData.quotNo
              params[params.length - 1].makerCd = this.headerData.makerCd
              params[params.length - 1].userId = this.$store.state.user.userId
              params[params.length - 1].porNo = this.dataList[i].shipNo
              params[params.length - 1].galAmt = this.dataList[i].galAmt
            }
          }
          //console.log('params', params)

          setSave1020Det(params).then(res => {
            // console.log('res', res)

            const msg = res.body

            if(msg === 'Y') {
              notify(this.$t('Detail is saved.'), 'success', 3000)
              this.btnRetrieve()
            } else {
              this.vToastify(this.$t("Detail Quotation submit. An error has occured while saving data to ...."), 'warn')
            }
          }).catch(error => {
            this.vToastify(error, 'warn')
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        true
      )
    },
    btnCopy(){
      const hvsIP = this.isHVSip
      const submitYn = this.headerData.submitYn ? this.headerData.submitYn : 'N'
      const receiveYn = this.headerData.receiveYn ? this.headerData.receiveYn : 'N'
      const isSave = this.saveChk && this.saveChk === 'Y' ? true : false

      if(hvsIP) {
        this.vToastify(this.$t('Warning : You access to HiP System at the HVS Company.<br>You cannot submit the quotation in the HVS.<br>nCall IT Department.(2487, 2496, 2497).'), 'warn')
        return
      }

      if(submitYn === 'Y') {
        return
      }
      
      if(isSave === false){ 
        this.vToastify(this.$t('Please save detail for first ship in quotation before copying.'), 'warn')
        return
      }

      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('There is no quotation no.'), 'warn')
        return
      }

      if(receiveYn !== 'Y') {
        this.vToastify(this.$t('Not yet Received'), 'warn')
        return
      }

      if(this.selectedShip.shipNo !== this.selectedShip.setShip) {
        this.vToastify(this.$t('Please select the first ship no in Series.'), 'warn')
        return
      }
      
      if(this.dataList.length === 0) {
        this.vToastify(this.$t('There is no data to copy series.'), 'warn')
        return
      }
     
      // console.log('submitYn', submitYn)

      this.vToastifyPrompt(
        this.$t('Do you want to Copy Series for this Quotation?'),
        'info',
        current => {
          this.openLoading('searching')
          
          let porNo = this.dataList[1].shipNo            
           
          let  param = {
            quotNo: this.selectedQuot.quotNo,
            shipNo: this.selectedShip.shipNo,
            porNo: porNo,
            makerCd: this.$store.state.user.makerCd,            
          }                    
          
          console.log('params', param)

          epmsa1020copy(param).then(res => {
            // console.log('res', res)

            const msg = res.body

            if(msg === 'Y') {
              notify(this.$t('Copy Series is successful.'), 'success', 3000)
              this.btnRetrieve()
            } else {
              this.vToastify(this.$t("An error has occured while copy series to ...."), 'warn')
            }
          }).catch(error => {
            this.vToastify(error, 'warn')
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        true
      )
    },
    async setShipRemain(){
     
        let  prChk = {
              quotNo: this.selectedQuot.quotNo,
              makerCd : this.$store.state.user.makerCd,                
            }          
      
       let shipRemainList = []
            
      await checkRemainShip(prChk).then(res => {
        shipRemainList = res.list;
      })           
      
      if(shipRemainList.length > 0){
        this.shipRemain = shipRemainList.map(item => item.shipNo).join(', ')
            this.vToastify(this.$t('Please check the ship no: ' + this.shipRemain + ' no have data before submit to HVS.'), 'warn')             
            return            
          }
    },
    btnSubmitToHVS() {           

          const submitYn = this.headerData.submitYn ? this.headerData.submitYn : 'N'
          const receiveYn = this.headerData.receiveYn ? this.headerData.receiveYn : 'N'
          const saveYn = this.headerData.saveYn ? this.headerData.saveYn : 'N'

          if(submitYn === 'Y') {           
            return     
          }
          
          if(!this.selectedQuot || !this.selectedQuot.quotNo) {
            this.vToastify(this.$t('There is no quotation no.'), 'warn')          
            return
          }

          if(receiveYn !== 'Y') {
            this.vToastify(this.$t('Not yet Received'), 'warn')           
            return
          }

          if(saveYn !== 'Y') {
            this.vToastify(this.$t('Not yet Saved'), 'warn')           
            return
          }   
          
          this.setShipRemain().then(()=>{
            if(this.shipRemain === '')
            {
                this.vToastifyPrompt(
                this.$t('Are you sure to submit the Quotation?'),
                'info',
                current => {
                  this.openLoading()

                  const param = this.$_.cloneDeep(this.headerData)
                  param.userId = this.$store.state.user.userId

                  console.log('param', param)

                  setSubmit1020Det(param).then(res => {
                    // console.log('res', res)

                    const msg = res.body

                    if(msg === 'OK') {
                      notify(this.$t('Submit is completed.'), 'success', 3000)
                      this.btnRetrieve()
                    } else {
                      this.vToastify(this.$t(msg), 'warn')
                    }
                  }).catch(error => {
                    this.vToastify(error, 'warn')
                  }).finally(() => {
                    this.endLoading()
                  })
                },
                null,
                false
              )
            }                         
          })        
    }
  }
}
</script>

<style lang="scss" scoped>
$redBtn: #FF0000;

.form-layout::v-deep .col {
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: gray;
  
  * {
    border: 0px none !important;
  }

  .row:not(.row__select-no) {
    border-width: 0 0 1px 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }

  .col:not(.quotNo) {
    border-width: 0 1px 0 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }
}
.formHeader {
   background-color: rgb(223, 227, 213);
   font-weight: bold;
   // border: 1px solid gray;
   color: black;
   font-size: 9pt;
 }

 .formHeader2 {
   background-color: rgb(214, 243, 247);
 }

.subTitle {
  font-weight: bold;
  color: black;
}
.subTitle2 {
  font-weight: bold;
  color: red;
}
.quotNo {
  font-weight: bold;
  border: 1px solid gray;
  border-bottom: 0px;
  color: #0000FF;
  font-size: 9pt;
}

::v-deep {
  [role=btnSave], [role=btnSubmitToHVS] {
    :not([disabled=disabled]) {
      .v-btn__content {
        div, i {
          color: #{$redBtn} !important;
        }
      }
    }
  }
}

::v-deep.grd-input.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
  background: transparent;

  input {
    text-align: right;
  }
}

.tr-row-template.first-row {
  td {    
    border-bottom:  1px solid #ddd !important;
    border-right:  1px solid #ddd !important;
    border-left:  1px solid #ddd !important;
  }

  td:first-of-type {
    border-left: none !important;
  }

  td:last-of-type {
    border-right: none !important;
  }
}

.tr-row-template.second-row {
  td {    
    border-bottom:  1px solid #ddd !important;
    border-right:  1px solid #ddd !important;
    border-left:  1px solid #ddd !important;
  }
}



</style>